export default {

	data() {
		return {
			MAX_DISPLAYABLE_VALUES: 2,
		};
	},

	computed: {
		displayedValues() {
			if (this.hasTruncated) {
				return this.values.slice(0, this.MAX_DISPLAYABLE_VALUES);
			}

			return this.values;
		},

		hasTruncated() {
			return this.values && this.values.length > this.MAX_DISPLAYABLE_VALUES;
		},
	},
};
